import { useLanguage } from "../i18n";
import { Reveal, Eyebrow } from "./Reveal";
import { PhotoSlot } from "./PhotoSlot";
import { PHOTOS } from "../data";

const Panel = ({ img, title, desc, note, testid, delay }) => (
  <Reveal delay={delay}>
    <div data-testid={testid} className="group">
      {img ? (
        <div className="overflow-hidden aspect-[16/11]">
          <img
            src={img}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
          />
        </div>
      ) : (
        <PhotoSlot className="aspect-[16/11]" />
      )}
      <h3 className="mt-7 font-display font-light text-2xl sm:text-3xl text-[#F5EFE6]">
        {title}
      </h3>
      <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#CBB9B0]">{desc}</p>
      <p className="mt-5 font-meta text-[10px] uppercase tracking-[0.25em] text-[#C69255]/80">
        {note}
      </p>
    </div>
  </Reveal>
);

export const Philosophy = () => {
  const { t } = useLanguage();
  return (
    <section
      id="cucina"
      data-testid="philosophy-section"
      className="relative py-24 sm:py-36 grain"
      style={{ backgroundColor: "#2C0F1A" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-baseline gap-5">
              <span className="font-display italic font-light text-6xl sm:text-7xl text-[#F5EFE6]/10 leading-none">
                02
              </span>
              <Eyebrow light>{t.philosophy.eyebrow}</Eyebrow>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-light text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.15] tracking-tight text-[#F5EFE6]">
              {t.philosophy.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 text-base leading-relaxed text-[#CBB9B0]">
              {t.philosophy.intro}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-12 lg:gap-16">
          <Panel
            img={PHOTOS.dishPrawn}
            title={t.philosophy.seaTitle}
            desc={t.philosophy.seaDesc}
            note={t.philosophy.seaNote}
            testid="philosophy-sea-card"
            delay={0.1}
          />
          <Panel
            img={PHOTOS.fire}
            title={t.philosophy.landTitle}
            desc={t.philosophy.landDesc}
            note={t.philosophy.landNote}
            testid="philosophy-land-card"
            delay={0.22}
          />
        </div>
      </div>
    </section>
  );
};
